const {
  checkForStockReportRateRequirements,
  buildStockReportRateQueryContext,
  buildStockReportRateSummaryQuery,
  getStockReportRateLevel
} = require('./operational/stock-report-rate')
const {
  getRevenueSummary: getRevenueSummaryData,
  getRevenueByLocationTable: getRevenueByLocationTableData,
  getRevenueByProductTable: getRevenueByProductTableData,
  getRevenueMissingPricesSummary: getRevenueMissingPricesSummaryData,
  getMonthlyRevenue: getMonthlyRevenueData,
  parseDateOnlyUtcOrThrow
} = require('./financial/revenue')

class AnalyticsApi {
  constructor (pgConnection, agaveAdapter) {
    this.pgConnection = pgConnection
    this.agaveAdapter = agaveAdapter
  }

  async getRevenueSummary ({ fromDate, toDate, organisationId, location, productSku }) {
    return getRevenueSummaryData({
      pgConnection: this.pgConnection,
      fromDate,
      toDate,
      organisationId,
      location,
      productSku
    })
  }

  async getRevenueByLocationTable ({ fromDate, toDate, organisationId, location, productSku }) {
    return getRevenueByLocationTableData({
      pgConnection: this.pgConnection,
      fromDate,
      toDate,
      organisationId,
      location,
      productSku
    })
  }

  async getRevenueByProductTable ({ fromDate, toDate, organisationId, location, productSku }) {
    return getRevenueByProductTableData({
      pgConnection: this.pgConnection,
      fromDate,
      toDate,
      organisationId,
      location,
      productSku
    })
  }

  async getRevenueMissingPricesSummary ({ fromDate, toDate, organisationId, location, productSku }) {
    return getRevenueMissingPricesSummaryData({
      pgConnection: this.pgConnection,
      fromDate,
      toDate,
      organisationId,
      location,
      productSku
    })
  }

  async getMonthlyRevenue ({ toDate, organisationId, location, productSku }) {
    return getMonthlyRevenueData({
      pgConnection: this.pgConnection,
      toDate,
      organisationId,
      location,
      productSku
    })
  }

  async getStockReportRateSummary ({ fromDate, toDate, programs, country, zone, state, lga, sdp }) {
    checkForStockReportRateRequirements(this.pgConnection, programs)
    const fromDateUtc = parseDateOnlyUtcOrThrow(fromDate, 'fromDate')
    const toDateUtc = parseDateOnlyUtcOrThrow(toDate, 'toDate')
    const toDateExclusiveUtc = new Date(toDateUtc)
    toDateExclusiveUtc.setUTCDate(toDateExclusiveUtc.getUTCDate() + 1)
    const { params, whereClauses } = buildStockReportRateQueryContext({
      programs,
      fromDateUtc,
      toDateExclusiveUtc,
      country,
      zone,
      state,
      lga,
      sdp
    })

    const query = buildStockReportRateSummaryQuery({
      whereClauses: whereClauses
    })

    const { rows: [summary = {}] } = await this.pgConnection.query(query, params)
    const expectedLocations = Number(summary.expected_locations || 0)
    const completedLocations = Number(summary.completed_locations || 0)
    const total = expectedLocations > 0 ? completedLocations / expectedLocations : null

    return {
      fromDate,
      toDate,
      country: country,
      zone: zone,
      state: state,
      lga: lga,
      sdp: sdp,
      programs: params[0],
      total,
      level: getStockReportRateLevel(total),
      completedLocations,
      expectedLocations
    }
  }

  fetchRevenueSummary (params) {
    return this.agaveAdapter.get('analytics/revenue/summary', params)
  }

  fetchRevenueByLocationTable (params) {
    return this.agaveAdapter.get('analytics/revenue/location-table', params)
  }

  fetchRevenueByProductTable (params) {
    return this.agaveAdapter.get('analytics/revenue/product-table', params)
  }

  fetchRevenueMissingPricesSummary (params) {
    return this.agaveAdapter.get('analytics/revenue/missing-prices-summary', params)
  }

  fetchMonthlyRevenue (params) {
    return this.agaveAdapter.get('analytics/revenue//monthly-revenue', params)
  }

  fetchStockReportRateSummary (params) {
    return this.agaveAdapter.get('analytics/stock-report-rate/summary', params)
  }
}

module.exports = AnalyticsApi
